export default {
      id: "search-usage",
      viewBox: "0 0 18 18",
      url: "/" + "img/marilyn-ui.svg#search",
      toString: function () {
        return this.url;
      }
    }